<template>
  <ForieLoader
    class="t3-loader"
    v-show="showLoader && this.$store.state.domainSystemX == 1"
  />
  <TeLoader
    class="t3-loader"
    v-show="showLoader && this.$store.state.domainSystemX == 2"
  />

  <div class="container-fuild home-banner">
    <div class="container">
      <div class="row">
        <div
          class="col-12 home-banner-title-area"
          :style="{
            'background-image':
              'url(' + require('/src/assets/img/thema-five-banner.jpg') + ')',
          }"
        >
          <section>
            <h1>{{ companyName }}</h1>
          </section>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fuild home-aboutus">
    <div class="container">
      <div class="d-flex home-aboutus-area">
        <div
          class="col-12 col-lg-6 home-aboutus-left"
          :style="{
            'background-image':
              'url(' + require('/src/assets/img/thema-five-about.jpg') + ')',
          }"
        ></div>
        <div class="col-12 col-lg-6 mb-5 mb-lg-0 home-aboutus-right">
          <strong>{{
            toTitles(this.$store.getters.getWordLocale("txt_hakkimizda"))
          }}</strong>
          <p>
            {{
              companyDescription.length > 500
                ? `${companyDescription.substr(0, 450)}...`
                : companyDescription
            }}
          </p>

          <router-link
            class="nav-link"
            :to="'/' + this.$store.state.langCodeX + '/about'"
            >{{
              toTitles(
                this.$store.getters.getWordLocale("txt_daha_fazla_bilgi")
              )
            }}</router-link
          >
        </div>
      </div>
    </div>
  </div>

  <div class="container-fuild home-product-area">
    <div class="container">
      <div class="row">
        <div v-bind:class="{'col-12': true, 'col-lg-6': !removeProductsSection, 'col-lg-12': removeProductsSection, 'home-product-left': true }">
          <strong>{{
            this.$store.getters.getWordLocale("txt_urunler")
          }}</strong>
          <p>
            {{
            this.$store.getters.getWordLocale("txt_urunlerimiz_yazisi")
          }}
          </p>
          <router-link
            class="btn all-product-btn"
            :to="
                '/' +
                this.$store.state.langCodeX +
                '/' +
                this.$store.state.singleCompanyUrlCountryX +
                '/export-products/' +
                this.$store.state.singleCompanyUrlNameX
              "
            >{{
              this.$store.getters.getWordLocale("txt_tum_urunler")
            }}</router-link
          >
        </div>
        <div v-if="!removeProductsSection" class="col-12 col-lg-6 home-product-right">
          <Carousel :settings="settings" :breakpoints="breakpoints">
            <Slide v-for="(product, index) in companyProducts" :key="index">
              <div class="carousel__item">
                <router-link
                  class="product-item"
                  :to="
                    '/' +
                    this.$store.state.langCodeX +
                    '/' +
                    product.productLink +
                    '/' +
                    this.$store.state.singleCompanyUrlNameX
                      .split(`-`)
                      .slice(0, 3)
                      .join(`-`) +
                    '/' +
                    this.$store.state.singleCompanyUrlCountryX +
                    '/export-products'
                  "
                >
                  <img
                    class="w-100"
                    :title="product.fullTitle"
                    :src="'https://cdn.turkishexporter.com.tr' + product.image"
                    alt=""
                  />
                </router-link>

                <small :title="product.fullTitle">{{ product.title }}</small>
              </div>
            </Slide>

            <template #addons>
              <div class="sider-btn">
                <Navigation />
              </div>
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fuild home-company-product-info-area">
    <div class="container">
      <div class="row">
        <div class="col-12 home-company-product-bg">
          <CompanyKeywords
            :companyName="companyName"
            :companyKeywords="
              companyKeywords != '' ? companyKeywords.split(',') : []
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

import CompanyKeywords from "./components/CompanyKeywords.vue";

export default {
  components: {
    ForieLoader,
    TeLoader,
    CompanyKeywords,
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      removeProductsSection: false,
      showLoader: true,
      countryName: "",
      productsKeywords: [],
      companyProducts: [
        {
          image: "/storage/images/general/no-image.png",
          title: "",
          description: "",
        },
      ],
      companyAddress: "",
      contactPerson: "",
      phone: "",
      companyName: "",
      companyDescription: "",
      companyKeywords: "",
      userId: 0,
      userDetails: [],
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        700: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 5,
          snapAlign: "start",
        },
      },
    };
  },
  methods: {
    async getCompanyInformation() {
      var result = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyInformation`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: this.$store.state.singleCompanyIdX,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.$store.state.singleCompanyFullInfoX = result;
      result.CompanyContactInformations.forEach((element) => {
        var address = element.Address;
        if (this.companyAddress == "") {
          this.companyAddress = address;
        }
        if (this.contactPerson == "") {
          this.contactPerson = element.ContactPearson;
        }

        element.Phones.forEach((tel) => {
          if (this.phone == "") {
            this.phone = tel;
          }
        });
      });
    },
    buildCompanyInfo() {
      this.$store.state.singleCompanyFullInfoX.CompanyContactInformations.forEach(
        (element) => {
          var address = element.Address;
          if (this.companyAddress == "") {
            this.companyAddress = address;
          }
          if (this.contactPerson == "") {
            this.contactPerson = element.ContactPearson;
          }

          element.Phones.forEach((tel) => {
            if (this.phone == "") {
              this.phone = tel;
            }
          });
        }
      );
    },
    async getCompanyProducts() {
      var companies = [this.$store.state.singleCompanyIdX];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyProducts`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companies: companies,
            count: 1000,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyProducts = data))
        .catch((err) => console.log(err.message));

      this.$store.state.singleCompanyFullProductsX = this.companyProducts;
      this.buildCompanyProducts(this.companyProducts);
    },
    buildCompanyProducts(variable) {
      var temp = [];
      if (variable.length > 0) {
        variable = variable[0].Products;
        var count = 0;
        variable.forEach((product) => {    
          if (count > 6){ return; }    
          if (product.Images.length > 0) {
            var id = parseInt(product.Images[0]._id);
            var image = product.Images[0].Image;
            var title =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Name
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Name;

            var fullTitle = title;
            title = title.length > 15 ? `${title.substr(0, 15)}...` : title;

            var description =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Description
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Description;

            var keywords =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Keywords
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Keywords;

            if (keywords != "" && keywords != undefined) {
              keywords.split(",").forEach((k) => {
                this.productsKeywords.push(k);
              });
            }

            var productLink = `${fullTitle
              .toLowerCase()
              .trim()
              .split(" ")
              .join("-")}-${id}`;

            productLink = productLink.replace(/[^a-zA-Z0-9,-]/g, "");
            productLink = productLink.replace(/---/g, "-");
            productLink = productLink.replace(/--/g, "-");

            temp.push({
              image: image,
              title: title,
              fullTitle: fullTitle,
              description: description,
              productLink: productLink,
            });
            count++;
          }
        });

        if (temp.length > 0) {
          this.companyProducts = [];
          this.companyProducts = temp;
        } else {
          this.removeProductsSection = true;
        }
      }

      this.showLoader = false;
    },
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    },
  },
  mounted() {
    
    this.showLoader = true;
    this.companyName =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    this.countryName =
      this.$store.state.singleCompanyDetailsX.Country.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Country.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    this.companyDescription =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) =>
          q.LangCode == this.$store.state.langCodeX &&
          q.DescriptionContent != null
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].DescriptionContent
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].DescriptionContent;

    this.fullDescription = this.companyDescription.length >= 250 ? false : true;

    this.companyKeywords =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Keywords
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Keywords;

    this.userId = parseInt(
      this.$store.state.singleCompanyDetailsX.rlt_User_Id
    );

    if (this.$store.state.singleCompanyFullInfoX.length == 0) {
      this.getCompanyInformation();
    } else {
      this.buildCompanyInfo();
    }

    if (this.$store.state.singleCompanyFullProductsX.length == 0) {
      this.getCompanyProducts();
    } else {
      this.buildCompanyProducts(this.$store.state.singleCompanyFullProductsX);
    }
  },
};
</script>

<style scoped>
.carousel {
  height: 400px;
}
.carousel > div > ol > li {
  margin: 0px 15px;
  height: 400px;
}
.carousel > div > ol > li .carousel__item img {
  width: 100%;
}

.carousel button {
  width: 50px !important;
  height: 50px !important;
  background-color: var(--m3--ref--tertiary--tertiary40) !important;
}

.page-laoder{
  position: fixed !important;
  background-color: transparent !important;
   top: 50%;  
   display: none !important;
}
</style>
